import cn from 'clsx'

import { SiteSettings as SiteSettingsType } from '../../../../apps/benmax/src/types/sanity.types'

type SiteSettingsProp = {
    siteSettings: SiteSettingsType
}

import Copy from '../Copy/Copy'
import ImageBox from '../ImageBox/ImageBox'
import NavLink from '../NavLink/NavLink'

import SocialLinks from './SocialLinks'

import { getSanityLink } from 'shared-functions'

import s from './Footer.module.sass'

export default function Footer({
    siteSettings,
    companyLogo,
    site,
}: {
    siteSettings: SiteSettingsProp
    companyLogo: any
    invertedStyle?: boolean
    site?: string
}) {
    const { siteSettings: siteSettingsData } = siteSettings

    const { acknowledgement, footerBrands, footerMenu, footerOffices, socialLinks } = siteSettingsData || {}

    const { title: menuTitle, menuItems } = footerMenu || {}

    const { title, brands } = footerBrands || {}

    const { logo, offices } = footerOffices || {}

    return (
        <footer className={cn(s.Footer, site === 'amos-air' && s.AmosAir)}>
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Offices}>
                    <div>
                        <div className={s.Logos}>
                            {companyLogo}
                            {logo && <ImageBox image={logo} />}
                        </div>
                        <ul>
                            {offices &&
                                offices.map((office, index) => {
                                    const { address, phone, email, additionalEmail, name } = office

                                    return (
                                        <li key={index}>
                                            {name && (
                                                <h6
                                                    dangerouslySetInnerHTML={{
                                                        __html: name,
                                                    }}
                                                />
                                            )}
                                            {(phone || email) && (
                                                <div className={s.OfficeLinks}>
                                                    {phone && (
                                                        <NavLink href={`tel:${phone}`} className={s.Link}>
                                                            {phone}
                                                        </NavLink>
                                                    )}
                                                    {email && (
                                                        <NavLink href={`mailto:${email}`} className={s.Link}>
                                                            {email}
                                                        </NavLink>
                                                    )}
                                                    {additionalEmail && (
                                                        <NavLink href={`mailto:${additionalEmail}`} className={s.Link}>
                                                            {additionalEmail}
                                                        </NavLink>
                                                    )}
                                                </div>
                                            )}
                                            {address && <Copy copy={address} size="xsmall" />}
                                        </li>
                                    )
                                })}
                        </ul>
                    </div>
                </div>
                <div className={s.Menu}>
                    <div>
                        {menuTitle && <h5 dangerouslySetInnerHTML={{ __html: menuTitle }} />}
                        <ul className={s.MenuList}>
                            {menuItems &&
                                menuItems.map((item, index) => {
                                    const link =
                                        item?.linkType === 'internal' || item?.linkType === 'external'
                                            ? getSanityLink(item) || null
                                            : null

                                    if (!link) return null

                                    return (
                                        <li key={index}>
                                            <NavLink href={link.url} className={s.Link}>
                                                {link.title}
                                            </NavLink>
                                        </li>
                                    )
                                })}
                        </ul>
                        <SocialLinks socialLinks={socialLinks} />
                    </div>
                </div>
                <div className={s.Brands}>
                    <div>
                        {title && <p dangerouslySetInnerHTML={{ __html: title }} />}
                        {brands && (
                            <ul>
                                {brands.map((brand, index) => {
                                    const { image, heightPercentage, link } = brand

                                    const baseHeight = 30
                                    const scaledHeight = Math.round(
                                        heightPercentage ? (heightPercentage / 100) * baseHeight : baseHeight,
                                    )

                                    const inner = (
                                        <div className={s.Brand} style={{ height: `${scaledHeight}px` }}>
                                            {image && <ImageBox image={image} alt="" />}
                                        </div>
                                    )
                                    return <li key={index}>{link ? <NavLink href={link}>{inner}</NavLink> : inner}</li>
                                })}
                            </ul>
                        )}
                    </div>
                </div>
                <div className={s.Acknowledgement}>
                    <Copy copy={acknowledgement} size="xsmall" />
                </div>
            </div>
        </footer>
    )
}
